import * as S from './styles'

interface ContentAccessButtonProps {
  text: string
  handler: (e: React.MouseEvent<HTMLButtonElement>) => void
}

const ContentAccessButton = ({ text, handler }: ContentAccessButtonProps) => {
  return (
    <S.ContentAccessButtonContainer
      id="btn_opencontent"
      type="button"
      className="btn md blue"
      onClick={handler}
    >
      {text}
    </S.ContentAccessButtonContainer>
  )
}

export default ContentAccessButton
